import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#13082A",
    padding: "0 0 1rem 0",
    minHeight: "85vh",
  },
}));
